const stickyPos = 100;
const nav = document.querySelector('.js-sticky-nav');
const scrollUpClasses = ['scroll-up', 'max-h-50', 'opacity-100', 'text-black'];
const scrollDownClasses = ['scroll-down', 'max-h-0', 'opacity-0', 'text-current'];
let lastScroll = 0;

const init = () => {
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll <= stickyPos) {
      nav.classList.remove(...scrollUpClasses);
      return;
    }

    if (currentScroll > lastScroll && !nav.classList.contains('scroll-down')) {
      nav.classList.remove(...scrollUpClasses);
      nav.classList.add(...scrollDownClasses);
    } else if (
      currentScroll < lastScroll
      && nav.classList.contains('scroll-down')
    ) {
      nav.classList.remove(...scrollDownClasses);
      nav.classList.add(...scrollUpClasses);
    }

    lastScroll = currentScroll;
  });
};

export default {
  init,
};
